(() => {
  if (window.rdModernCollectionBound) return;
  window.rdModernCollectionBound = true;
  const SELECTOR = '[data-rd-collection]';
  const PRODUCT_CACHE = new Map();
  const PRODUCT_PAGE_CACHE = new Map();

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initCollection);
  }

  function initCollection(root) {
    if (!root || root.dataset.rdReady === 'true') return;
    root.dataset.rdReady = 'true';

    const drawer = root.querySelector('[data-rd-filter-drawer]');
    const drawerPanel = drawer?.querySelector('.rd-collection__drawer-panel');
    const openFilterButton = root.querySelector('[data-rd-filter-open]');
    const closeFilterButtons = drawer ? [...drawer.querySelectorAll('[data-rd-filter-close]')] : [];
    const desktopFilterMedia = window.matchMedia?.('(min-width: 990px)');
    const mobileControlsMedia = window.matchMedia?.('(max-width: 749px)');
    const mobileTools = root.querySelector('[data-rd-mobile-tools]');
    const mobileCategories = root.querySelector('[data-rd-mobile-categories]');
    const filterGroups = [...root.querySelectorAll('[data-rd-filter-group]')];
    const stickyHeaders = [...document.querySelectorAll('.header-section, .js-header, sticky-header, .header-wrapper')]
      .filter(header => !root.contains(header));
    let desktopSidebar = false;
    const sortSelect = root.querySelector('[data-rd-sort]');
    const filterForm = root.querySelector('[data-rd-filter-form]');
    const filterError = root.querySelector('[data-rd-filter-error]');
    const priceMin = filterForm?.querySelector('[data-rd-price-min]');
    const priceMax = filterForm?.querySelector('[data-rd-price-max]');
    const layoutStatus = root.querySelector('[data-rd-layout-status]');
    const layoutButtons = [...root.querySelectorAll('button[data-rd-layout]')];

    const grid = root.querySelector('[data-rd-product-grid]');
    const loadMore = root.querySelector('[data-rd-load-more]');
    const loadButton = loadMore?.querySelector('[data-rd-load-button]');
    const loadLabel = loadMore?.querySelector('[data-rd-load-label]');
    const loadStatus = loadMore?.querySelector('[data-rd-load-status]');
    const visibleCount = loadMore?.querySelector('[data-rd-visible-count]');
    const progressBar = loadMore?.querySelector('[data-rd-progress-bar]');
    const sectionId = root.dataset.sectionId || '';
    const swatchInteraction = root.dataset.swatchInteraction || 'hover_click';
    const supportsFineHover = window.matchMedia?.('(hover: hover) and (pointer: fine)').matches ?? true;

    const quickModal = root.querySelector('[data-rd-quick-buy-modal]');
    const quickPanel = quickModal?.querySelector('.rd-quick-buy__panel');
    const quickCloseButtons = quickModal ? [...quickModal.querySelectorAll('[data-rd-quick-buy-close]')] : [];
    const quickImage = quickModal?.querySelector('[data-rd-quick-buy-image]');
    const quickImageStage = quickModal?.querySelector('.rd-quick-buy__image-stage');
    const quickThumbnails = quickModal?.querySelector('[data-rd-quick-buy-thumbnails]');
    const quickImageCount = quickModal?.querySelector('[data-rd-image-count]');
    const quickGalleryPrev = quickModal?.querySelector('[data-rd-gallery-prev]');
    const quickGalleryNext = quickModal?.querySelector('[data-rd-gallery-next]');
    const quickTitle = quickModal?.querySelector('[data-rd-quick-buy-title]');
    const quickPrice = quickModal?.querySelector('[data-rd-quick-buy-price]');
    const quickDescription = quickModal?.querySelector('[data-rd-quick-buy-description]');
    const quickForm = quickModal?.querySelector('[data-rd-quick-buy-form]');
    const quickOptions = quickModal?.querySelector('[data-rd-quick-buy-options]');
    const quickQuantity = quickModal?.querySelector('[data-rd-quantity]');
    const quickAdd = quickModal?.querySelector('[data-rd-quick-buy-add]');
    const quickAddLabel = quickModal?.querySelector('[data-rd-quick-buy-add-label]');
    const quickStatus = quickModal?.querySelector('[data-rd-quick-buy-status]');
    const quickDetails = quickModal?.querySelector('[data-rd-quick-buy-details]');
    const quickCart = quickModal?.querySelector('[data-rd-quick-buy-cart]');
    const quickTabs = quickModal?.querySelector('[data-rd-quick-buy-tabs]');
    const quickDots = quickModal?.querySelector('[data-rd-quick-buy-dots]');
    const quickSpecs = quickModal?.querySelector('[data-rd-quick-buy-specifications]');
    const quickTrust = quickModal?.querySelector('[data-rd-quick-buy-trust]');
    const quickRetry = quickModal?.querySelector('[data-rd-quick-buy-retry]');
    const quickImageError = quickModal?.querySelector('[data-rd-image-error]');
    const quickScroll = quickModal?.querySelector('.rd-quick-buy__scroll');
    let quickSwatchOverrides = [];
    try {
      quickSwatchOverrides = JSON.parse(root.querySelector('[data-rd-quick-swatch-overrides]')?.textContent || '[]');
    } catch (_) {}

    let previousActive = null;
    let originalOverflow = '';
    let bodyLocked = false;
    let revealObserver = null;
    let imageSizeObserver = null;
    const inertBackground = new Map();
    let requestController = null;
    let quickRequestController = null;
    let quickResetTimer = null;
    let loading = false;
    let nextUrl = loadMore?.dataset.nextUrl || '';
    let quickProduct = null;
    let quickProductUrl = '';
    let selectedOptions = [];
    let selectedVariant = null;
    let quickImages = [];
    let quickImageIndex = 0;
    let quickTouchStartX = null;
    let quickTouchStartY = null;
    let collectionFilters = null;
    let quickAdding = false;
    let mobileLayoutFrame = null;
    let mobileLayoutObserver = null;
    let headerMutationObserver = null;
    let headerTransitionTimer = null;
    let disposed = false;

    function syncFilterGroups() {
      const desktop = Boolean(desktopFilterMedia?.matches);
      filterGroups.forEach(group => {
        const selected = [...group.querySelectorAll('input')].some(input =>
          (input.type === 'checkbox' && input.checked) ||
          ((input.hasAttribute('data-rd-price-min') || input.hasAttribute('data-rd-price-max')) && input.value.trim() !== '')
        );
        group.open = selected || group.dataset.rdFilterActive === 'true' || group.dataset[desktop ? 'rdOpenDesktop' : 'rdOpenMobile'] === 'true';
      });
    }

    function visibleHeaderBottom() {
      if (root.dataset.mobileHeaderAuto === 'false') return 0;
      let bottom = 0;
      stickyHeaders.forEach(header => {
        const wrapper = header.closest('.header-section, .header-wrapper') || header;
        if (wrapper.classList.contains('is-collapsed') || header.hidden) return;
        const position = getComputedStyle(wrapper).position;
        const ownPosition = getComputedStyle(header).position;
        if (!['sticky', 'fixed'].includes(position) && !['sticky', 'fixed'].includes(ownPosition)) return;
        const bounds = header.getBoundingClientRect();
        if (bounds.width > 0 && bounds.height > 0 && bounds.top < window.innerHeight * .5 && bounds.bottom > 0) {
          bottom = Math.max(bottom, bounds.bottom);
        }
      });
      return Math.round(bottom);
    }

    function syncMobileControls() {
      mobileLayoutFrame = null;
      if (disposed) return;
      const mobile = Boolean(mobileControlsMedia?.matches);
      if (!mobile) {
        root.dataset.mobileToolsActive = 'false';
        root.style.removeProperty('--rdc-mobile-header-overlap');
        return;
      }
      const headerBottom = visibleHeaderBottom();
      root.style.setProperty('--rdc-mobile-header-overlap', `${headerBottom}px`);
      if (!mobileTools || root.dataset.mobileToolbar !== 'bottom') return;
      const exists = [...mobileTools.children].some(control => getComputedStyle(control).display !== 'none');
      root.dataset.mobileToolsExist = String(exists);
      const height = exists ? Math.ceil(mobileTools.getBoundingClientRect().height) : 0;
      const previousHeight = root.style.getPropertyValue('--rdc-mobile-tools-height');
      if (previousHeight !== `${height}px`) root.style.setProperty('--rdc-mobile-tools-height', `${height}px`);
      const bounds = root.getBoundingClientRect();
      root.dataset.mobileToolsActive = String(exists && bounds.top < window.innerHeight - height && bounds.bottom > headerBottom + height);
    }

    function queueMobileLayout() {
      if (disposed || mobileLayoutFrame !== null) return;
      mobileLayoutFrame = requestAnimationFrame(syncMobileControls);
    }

    function settleHeaderTransition() {
      queueMobileLayout();
      clearTimeout(headerTransitionTimer);
      headerTransitionTimer = setTimeout(queueMobileLayout, 450);
    }

    function handleFilterBreakpoint() {
      syncFilterGroups();
      syncFilterPresentation();
      queueMobileLayout();
    }

    function handleBlockSelect(event) {
      const id = event.detail?.blockId;
      const group = filterGroups.find(item => item.dataset.rdFilterRule === id);
      if (!group || getComputedStyle(group).display === 'none') return;
      group.open = true;
      if (!desktopSidebar) openDrawer();
      group.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    }

    function lockBody() {
      if (bodyLocked) return;
      originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      bodyLocked = true;
    }

    function unlockBody() {
      if (!bodyLocked) return;
      document.body.style.overflow = originalOverflow;
      bodyLocked = false;
    }

    function restoreBackground() {
      inertBackground.forEach((wasInert, element) => { element.inert = wasInert; });
      inertBackground.clear();
    }

    function isolateDialog(container) {
      restoreBackground();
      let branch = container;
      while (branch && branch !== document.body) {
        const parent = branch.parentElement;
        if (!parent) break;
        [...parent.children].forEach(sibling => {
          if (sibling === branch || !('inert' in sibling) || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;
          inertBackground.set(sibling, sibling.inert);
          sibling.inert = true;
        });
        branch = parent;
      }
    }

    function openDrawer() {
      if (!drawer || desktopSidebar) return;

      previousActive = document.activeElement;
      drawer.dataset.open = 'true';
      drawer.setAttribute('aria-hidden', 'false');
      openFilterButton?.setAttribute('aria-expanded', 'true');
      lockBody();
      isolateDialog(drawer);

      requestAnimationFrame(() => {
        if (drawer.dataset.open === 'true') drawerPanel?.focus({ preventScroll: true });
      });
    }

    function closeDrawer({ restoreFocus = true } = {}) {
      if (!drawer || desktopSidebar) return;

      drawer.dataset.open = 'false';
      drawer.setAttribute('aria-hidden', 'true');
      openFilterButton?.setAttribute('aria-expanded', 'false');

      if (quickModal?.dataset.open !== 'true') {
        restoreBackground();
        unlockBody();
      }

      if (restoreFocus && previousActive?.focus) {
        try {
          previousActive.focus({ preventScroll: true });
        } catch (_) {}
      }
    }

    function activeDialog() {
      if (quickModal?.dataset.open === 'true') return quickPanel;
      if (!desktopSidebar && drawer?.dataset.open === 'true') return drawerPanel;
      return null;
    }

    function syncFilterPresentation() {
      if (!drawer) return;
      const sidebar = root.dataset.filterStyle === 'sidebar' && root.dataset.desktopFilterGroups !== '0' && Boolean(desktopFilterMedia?.matches);
      const wasSidebar = desktopSidebar;
      const focused = document.activeElement;

      if (sidebar && drawer.dataset.open === 'true') closeDrawer({ restoreFocus: false });
      desktopSidebar = sidebar;
      drawerPanel?.setAttribute('role', sidebar ? 'complementary' : 'dialog');

      if (sidebar) {
        drawer.dataset.open = 'false';
        drawer.setAttribute('aria-hidden', 'false');
        drawerPanel?.removeAttribute('aria-modal');
        openFilterButton?.setAttribute('aria-expanded', 'false');
        collectionFilters?.load?.();
        if (focused === openFilterButton || closeFilterButtons.some(button => button.contains(focused))) {
          requestAnimationFrame(() => {
            if (!desktopSidebar || quickModal?.dataset.open === 'true') return;
            (filterForm?.querySelector('summary, input:not([disabled]):not([type="hidden"])') || drawerPanel)?.focus({ preventScroll: true });
          });
        }
      } else {
        drawerPanel?.setAttribute('aria-modal', 'true');
        if (wasSidebar) {
          drawer.dataset.open = 'false';
          openFilterButton?.setAttribute('aria-expanded', 'false');
          if (drawer.contains(focused)) {
            requestAnimationFrame(() => {
              if (!desktopSidebar && drawer.dataset.open !== 'true' && quickModal?.dataset.open !== 'true') openFilterButton?.focus({ preventScroll: true });
            });
          }
        }
        drawer.setAttribute('aria-hidden', String(drawer.dataset.open !== 'true'));
      }
      requestAnimationFrame(updateCardImageSizes);
    }

    function focusables(container) {
      if (!container) return [];

      return [...container.querySelectorAll(
        'a[href]:not([hidden]), button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
      )].filter(element => element.offsetParent !== null);
    }

    function handleKeydown(event) {
      const dialog = activeDialog();
      if (!dialog) return;

      if (event.key === 'Escape') {
        event.preventDefault();

        if (quickModal?.dataset.open === 'true') {
          closeQuickBuy();
        } else {
          closeDrawer();
        }
        return;
      }

      if (quickModal?.dataset.open === 'true' &&
          ['ArrowLeft', 'ArrowRight'].includes(event.key) &&
          document.activeElement?.closest('[data-rd-quick-buy-dots], [data-rd-quick-buy-thumbnails], .rd-quick-buy__image-stage')) {
        event.preventDefault();
        showQuickImage(quickImageIndex + (event.key === 'ArrowRight' ? 1 : -1));
        quickDots?.querySelector('[aria-current="true"]')?.focus({ preventScroll: true });
        return;
      }

      if (event.key !== 'Tab') return;

      const items = focusables(dialog);

      if (!items.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }

      const first = items[0];
      const last = items[items.length - 1];

      if (document.activeElement === dialog || !dialog.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function createRevealObserver() {
      if (root.dataset.reveal !== 'true' || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return null;
      if (!('IntersectionObserver' in window)) return null;

      return new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver?.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -4% 0px',
        threshold: 0.04
      });
    }

    function reveal(items) {
      items.forEach(item => {
        if (revealObserver) {
          revealObserver.observe(item);
        } else {
          item.classList.add('is-visible');
        }
      });
    }

    function updateProgress(visible, total) {
      const safeVisible = Math.max(0, Math.min(visible, total));
      const percentage = total > 0 ? (safeVisible / total) * 100 : 100;

      if (visibleCount) visibleCount.textContent = String(safeVisible);
      if (progressBar) progressBar.style.width = `${percentage}%`;

      if (loadMore) {
        loadMore.dataset.visible = String(safeVisible);
        loadMore.dataset.total = String(total);
      }
    }

    function requestUrl(url) {
      const request = new URL(url, window.location.origin);

      if (sectionId) {
        request.searchParams.set('section_id', sectionId);
      }

      return request.toString();
    }

    function updateCardImageSizes() {
      if (!grid) return;
      grid.querySelectorAll('[data-rd-product-card]').forEach(card => {
        card.querySelectorAll('img[srcset]').forEach(image => {
          const width = Math.ceil(image.getBoundingClientRect().width);
          if (width <= 0) return;
          image.setAttribute('sizes', `${width}px`);
          if (image.classList.contains('rd-product-card__image--primary') && card._rdSelectedImage?.src === image.getAttribute('src')) {
            card._rdSelectedImage.sizes = `${width}px`;
          }
        });
      });
    }

    function changeLayout(button) {
      const layout = button.dataset.rdLayout;
      if (!['spacious', 'compact'].includes(layout)) return;
      root.dataset.layout = layout;
      layoutButtons.forEach(candidate => candidate.setAttribute('aria-pressed', String(candidate === button)));
      if (layoutStatus) layoutStatus.textContent = button.getAttribute('aria-label') || '';
      requestAnimationFrame(updateCardImageSizes);
    }

    function changeSort() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      url.searchParams.delete('rd_page');
      window.location.assign(url.toString());
    }

    function applyFilters(event) {
      event.preventDefault();
      if (!filterForm) return;
      if (filterError) filterError.hidden = true;
      if (priceMin?.value && priceMax?.value && Number(priceMin.value) > Number(priceMax.value)) {
        if (filterError) filterError.hidden = false;
        priceMin.focus();
        return;
      }
      if (!filterForm.checkValidity()) {
        filterForm.reportValidity();
        return;
      }
      const url = new URL(filterForm.action, window.location.origin);
      url.search = window.location.search;
      [...url.searchParams.keys()].forEach(key => {
        if (key.startsWith('filter.') || key === 'page' || key === 'sort_by' || ['rd_price_from', 'rd_price_to', 'rd_color', 'rd_page'].includes(key)) url.searchParams.delete(key);
      });
      for (const [key, value] of new FormData(filterForm)) {
        if (String(value).trim() !== '') url.searchParams.append(key, value);
      }
      window.location.assign(url.toString());
    }

    function setLoadingState(isLoading) {
      loading = isLoading;
      if (!loadButton) return;

      loadButton.disabled = isLoading;
      loadButton.setAttribute('aria-busy', String(isLoading));

      if (loadLabel) {
        loadLabel.textContent = isLoading
          ? (loadMore.dataset.loadingLabel || 'LOADING')
          : (loadMore.dataset.loadLabel || 'LOAD MORE');
      }
    }

    function setCompleteState() {
      nextUrl = '';
      if (!loadMore || !loadButton) return;

      loadMore.dataset.complete = 'true';
      loadButton.disabled = true;
      loadButton.setAttribute('aria-busy', 'false');

      if (loadLabel) {
        loadLabel.textContent = loadMore.dataset.completeLabel || 'ALL PIECES VIEWED';
      }
    }

    async function loadNextPage() {
      if (loading || !nextUrl || !grid || !loadMore || !loadButton) return;

      setLoadingState(true);
      if (loadStatus) loadStatus.textContent = '';

      requestController?.abort();
      requestController = new AbortController();

      try {
        const response = await fetch(requestUrl(nextUrl), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: requestController.signal
        });

        if (!response.ok) {
          throw new Error(`Collection request failed: ${response.status}`);
        }

        const markup = await response.text();
        const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
        const renderedRoots = [...documentFragment.querySelectorAll(SELECTOR)];
        const renderedRoot = renderedRoots.find(candidate => candidate.dataset.sectionId === sectionId) || renderedRoots[0];
        const renderedGrid = renderedRoot?.querySelector('[data-rd-product-grid]');
        const renderedLoadMore = renderedRoot?.querySelector('[data-rd-load-more]');
        const newCards = renderedGrid
          ? [...renderedGrid.querySelectorAll(':scope > [data-rd-product-card]')]
          : [];

        if (!renderedRoot || !renderedGrid || !newCards.length) {
          throw new Error('No additional collection products were returned.');
        }

        const batchSize = newCards.length;
        const fragment = document.createDocumentFragment();

        newCards.forEach((card, index) => {
          card.style.setProperty('--rd-delay', `${Math.min(index, 7) * 45}ms`);
          fragment.appendChild(card);
        });

        grid.appendChild(fragment);
        applyCardSwatchFallbacks(grid);
        reveal(newCards);
        updateCardImageSizes();

        const total = Number(renderedLoadMore?.dataset.total || loadMore.dataset.total || 0);
        const renderedVisible = grid.querySelectorAll(':scope > [data-rd-product-card]').length;

        nextUrl = renderedLoadMore?.dataset.nextUrl || '';
        loadMore.dataset.nextUrl = nextUrl;
        updateProgress(renderedVisible, total);

        if (loadStatus) loadStatus.textContent = `${batchSize} more pieces loaded.`;

        if (!nextUrl || renderedVisible >= total) {
          setCompleteState();
        } else {
          setLoadingState(false);
        }
      } catch (error) {
        if (error.name === 'AbortError') return;

        loading = false;
        loadButton.disabled = false;
        loadButton.setAttribute('aria-busy', 'false');

        if (loadLabel) loadLabel.textContent = loadMore.dataset.errorLabel || 'TRY AGAIN';
        if (loadStatus) loadStatus.textContent = 'Unable to load more pieces. Please try again.';
        console.error('[RD Luxury Collection]', error);
      }
    }

    function productEndpoint(productUrl) {
      const url = new URL(productUrl, window.location.origin);
      const pathMatch = url.pathname.match(/\/products\/([^/]+)/);
      if (!pathMatch) throw new Error('Invalid product URL.');

      const routeRoot = window.Shopify?.routes?.root || '/';
      return `${routeRoot}products/${pathMatch[1]}.js`;
    }

    async function fetchProduct(productUrl, controller) {
      const endpoint = productEndpoint(productUrl);

      if (PRODUCT_CACHE.has(endpoint)) return PRODUCT_CACHE.get(endpoint);

      const response = await fetch(endpoint, {
        headers: { Accept: 'application/json' },
        signal: controller.signal
      });

      if (!response.ok) throw new Error(`Product request failed: ${response.status}`);

      const product = await response.json();
      PRODUCT_CACHE.set(endpoint, product);
      return product;
    }

    async function fetchProductDetails(productUrl, controller) {
      const pageUrl = new URL(productUrl, window.location.origin);
      // Specifications and swatch artwork belong to the product, across its variants.
      pageUrl.searchParams.delete('variant');
      const endpoint = pageUrl.toString();
      if (PRODUCT_PAGE_CACHE.has(endpoint)) return PRODUCT_PAGE_CACHE.get(endpoint);

      const response = await fetch(endpoint, {
        headers: { Accept: 'text/html' },
        signal: controller.signal
      });

      if (!response.ok) throw new Error(`Product page request failed: ${response.status}`);

      const html = await response.text();
      const page = new DOMParser().parseFromString(html, 'text/html');
      const source = page.querySelector('[data-rd-product-tabs], .product-tabs.tabs--underline');
      const buttons = [...(source?.querySelectorAll('.product-tabs__nav .tab-button, [role="tab"]') || [])];
      const panels = [...(source?.querySelectorAll('.product-tabs__content .tab-content, [role="tabpanel"]') || [])];
      const tabs = buttons.slice(0, panels.length).map((button, index) => ({
        label: (button.textContent || '').replace(/\s+/g, ' ').trim(),
        html: sanitizeProductDetailHtml(panels[index]?.innerHTML || '')
      })).filter(tab => tab.label && tab.html);

      const specs = [];
      (source || page).querySelectorAll('.spec_container .spec_head').forEach(label => {
        let value = label.nextElementSibling;
        while (value && !value.classList.contains('spec_fill') && !value.classList.contains('spec_head')) value = value.nextElementSibling;
        if (value?.classList.contains('spec_fill')) {
          specs.push({ label: cleanText(label.textContent), value: cleanText(value.textContent) });
        }
      });
      if (!specs.length) {
        (source || page).querySelectorAll('table tr').forEach(row => {
          const cells = row.querySelectorAll('th,td');
          if (cells.length > 1) specs.push({ label: cleanText(cells[0].textContent).replace(/\s*:\s*$/, ''), value: cleanText(cells[cells.length - 1].textContent) });
        });
      }
      const swatches = [];
      page.querySelectorAll('.rd-option__button--color[data-variant-name]').forEach(label => {
        const rawImage = label.style.getPropertyValue('--rd-color-swatch-image').trim();
        const sourceImage = rawImage.match(/^url\(\s*(['"]?)(.*?)\1\s*\)$/i)?.[2];
        const image = safeImageUrl(sourceImage);
        if (image) swatches.push({ value: label.dataset.variantName, image });
      });
      const statement = page.querySelector('.rd-brand-statement__inner');
      const rating = cleanText(statement?.querySelector('.rd-brand-statement__rating')?.textContent);
      const reviewText = cleanText(statement?.querySelector('.rd-brand-statement__review-text')?.textContent);
      const hotels = [...(statement?.querySelectorAll('.rd-brand-statement__logo-item') || [])].map(node => cleanText(node.textContent)).filter(Boolean);
      const details = { tabs, specs: specs.filter(item => item.label && item.value), swatches, trust: { rating, reviewText, hotels } };
      PRODUCT_PAGE_CACHE.set(endpoint, details);
      return details;
    }

    function cleanText(value = '') {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }

    function safeImageUrl(value) {
      if (!value) return '';
      try {
        const url = new URL(value, window.location.origin);
        return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
      } catch (_) { return ''; }
    }

    function normalizeImageUrl(source) {
      if (!source) return '';
      if (source.startsWith('//')) return `${window.location.protocol}${source}`;
      return source;
    }

    function swatchFallback(value = '') {
      const key = String(value).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      const rules = [
        [/pearl|white|opal/, '#eeeae0'],
        [/caviar|jet|black|onyx/, '#242326'],
        [/ruby|scarlet|siam|garnet|\bred\b/, '#9d2437'],
        [/sapphire|blue|indigo|capri/, '#315a83'],
        [/aqua|turquoise|zircon/, '#62aeb5'],
        [/emerald|peridot|erinite|chrysolite|green/, '#39705b'],
        [/fuchsia|rose|pink|rosaline/, '#c05b7e'],
        [/amethyst|violet|purple/, '#785c8e'],
        [/hyacinth|orange|padparadscha/, '#d7783d'],
        [/aurum|gold|topaz|sunshine|silk|champagne/, '#c9a253'],
        [/silver|chrome|argent|metallic/, '#9c9d9d'],
        [/copper|bronze|brown/, '#9f684b'],
        [/crystal|clear/, 'linear-gradient(135deg, #ffffff 10%, #dce8ec 48%, #f4dfe8 82%)'],
        [/pop/, 'linear-gradient(135deg, #d2496f, #e6ae4a 48%, #3a8790)'],
        [/glam/, 'linear-gradient(135deg, #8e6b2e, #e6cf91 50%, #8d516d)']
      ];
      return rules.find(([pattern]) => pattern.test(key))?.[1] ||
        'linear-gradient(135deg, #d8d6d0, #f2efe8 48%, #b9b5ad)';
    }

    function applyCardSwatchFallbacks(scope = root) {
      scope.querySelectorAll('[data-rd-card-swatch]').forEach(button => {
        const hasImage = button.style.getPropertyValue('--rd-swatch-image').trim();
        const hasColor = button.style.getPropertyValue('--rd-swatch').trim();
        if (!hasImage && !hasColor) {
          button.style.setProperty('--rd-swatch', swatchFallback(button.dataset.swatchValue));
        }
      });

      scope.querySelectorAll('[data-rd-product-card]').forEach(card => {
        if (card._rdSelectedImage) return;
        card._rdSelectedImage = captureCardImage(card);
      });
    }

    function captureCardImage(card) {
      const image = card?.querySelector('.rd-product-card__image--primary');
      if (!image) return null;
      return {
        src: image.getAttribute('src') || '',
        srcset: image.getAttribute('srcset') || '',
        sizes: image.getAttribute('sizes') || '',
        alt: image.alt || '',
        swatchLabel: card.querySelector('[data-rd-swatch-label]')?.textContent || '',
        hasPreview: card.classList.contains('has-swatch-preview')
      };
    }

    function applyCardImage(card, imageUrl, label = '') {
      const primaryImage = card?.querySelector('.rd-product-card__image--primary');
      const normalized = normalizeImageUrl(imageUrl);
      if (!primaryImage || !normalized) return false;

      primaryImage.src = normalized;
      primaryImage.removeAttribute('srcset');
      primaryImage.removeAttribute('sizes');
      primaryImage.alt = `${card.querySelector('.rd-product-card__title')?.textContent?.trim() || 'Product'} — ${label}`.trim();
      const swatchLabel = card.querySelector('[data-rd-swatch-label]');
      if (swatchLabel) swatchLabel.textContent = label;
      card.classList.add('has-swatch-preview');
      return true;
    }

    function restoreCardSwatchPreview(group) {
      const card = group?.closest('[data-rd-product-card]');
      const state = card?._rdSelectedImage;
      const primaryImage = card?.querySelector('.rd-product-card__image--primary');
      if (!card || !state || !primaryImage) return;

      primaryImage.src = state.src;
      if (state.srcset) primaryImage.setAttribute('srcset', state.srcset);
      else primaryImage.removeAttribute('srcset');
      if (state.sizes) primaryImage.setAttribute('sizes', state.sizes);
      else primaryImage.removeAttribute('sizes');
      primaryImage.alt = state.alt;
      const swatchLabel = card.querySelector('[data-rd-swatch-label]');
      if (swatchLabel) swatchLabel.textContent = state.swatchLabel;
      card.classList.toggle('has-swatch-preview', state.hasPreview);
      group.querySelectorAll('[data-rd-card-swatch]').forEach(button => button.classList.remove('is-hovered'));
    }

    function previewCardSwatch(button) {
      const card = button.closest('[data-rd-product-card]');
      if (!card) return;

      const group = button.closest('.rd-product-card__swatches');
      group?.querySelectorAll('[data-rd-card-swatch]').forEach(candidate => {
        candidate.classList.toggle('is-hovered', candidate === button);
      });

      applyCardImage(card, button.dataset.imageUrl, button.dataset.swatchValue || '');
    }

    function selectCardSwatch(button) {
      const card = button.closest('[data-rd-product-card]');
      if (!card) return;

      card.querySelectorAll('[data-rd-card-swatch]').forEach(candidate => {
        const selected = candidate === button;
        candidate.classList.toggle('is-selected', selected);
        candidate.setAttribute('aria-pressed', String(selected));
      });

      if (applyCardImage(card, button.dataset.imageUrl, button.dataset.swatchValue || '')) {
        card._rdSelectedImage = captureCardImage(card);
      }
      const swatchLabel = card.querySelector('[data-rd-swatch-label]');
      if (swatchLabel) swatchLabel.textContent = button.dataset.swatchValue || '';
      const price = card.querySelector('[data-rd-card-price]');
      if (price && button.dataset.variantPrice) {
        const currentPrice = document.createElement('span');
        currentPrice.textContent = button.dataset.variantPrice;
        price.replaceChildren(currentPrice);
        if (button.dataset.variantCompare) {
          const comparePrice = document.createElement('s');
          comparePrice.textContent = button.dataset.variantCompare;
          price.appendChild(comparePrice);
        }
      }

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      card.querySelectorAll('.rd-product-card__image-link, .rd-product-card__title a').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', variantId);
        link.href = `${url.pathname}${url.search}${url.hash}`;
      });

      card.querySelectorAll('[data-rd-quick-buy-open]').forEach(trigger => {
        const url = new URL(trigger.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', variantId);
        trigger.dataset.productUrl = `${url.pathname}${url.search}${url.hash}`;
      });
    }

    function handleSwatchPointerOver(event) {
      if (!supportsFineHover || swatchInteraction === 'click') return;
      const swatch = event.target.closest('[data-rd-card-swatch]');
      if (!swatch || !root.contains(swatch) || swatch.contains(event.relatedTarget)) return;
      previewCardSwatch(swatch);
    }

    function handleSwatchPointerOut(event) {
      if (!supportsFineHover || swatchInteraction === 'click') return;
      const group = event.target.closest('.rd-product-card__swatches');
      if (!group || !root.contains(group) || group.contains(event.relatedTarget)) return;
      restoreCardSwatchPreview(group);
    }

    function sanitizeProductDetailHtml(html) {
      const template = document.createElement('template');
      template.innerHTML = html;
      template.content.querySelectorAll('script, style, form, input, select, textarea, button, iframe, object, embed').forEach(node => node.remove());
      template.content.querySelectorAll('*').forEach(node => {
        [...node.attributes].forEach(attribute => {
          if (/^on/i.test(attribute.name) || attribute.name === 'id' || attribute.name.startsWith('aria-')) {
            node.removeAttribute(attribute.name);
          }
          if (['href', 'src', 'xlink:href'].includes(attribute.name)) {
            try {
              const url = new URL(attribute.value, window.location.origin);
              const allowed = ['http:', 'https:', ...(attribute.name === 'href' ? ['mailto:', 'tel:'] : [])];
              if (!allowed.includes(url.protocol)) node.removeAttribute(attribute.name);
            } catch (_) { node.removeAttribute(attribute.name); }
          }
        });
      });
      return template.innerHTML.trim();
    }

    function formatMoney(cents) {
      const amount = Number(cents || 0) / 100;
      const locale = document.documentElement.lang || navigator.language || 'en';
      const currency = root.dataset.currency || window.Shopify?.currency?.active || 'USD';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          currencyDisplay: quickModal?.dataset.currencyDisplay === 'code' ? 'code' : 'symbol',
          ...(quickModal?.dataset.currencyDisplay === 'code' && !['JPY', 'KRW', 'VND'].includes(currency) ? { minimumFractionDigits: Number(cents) % 100 === 0 ? 0 : 2 } : {})
        }).format(amount);
      } catch (_) {
        return `${currency} ${amount.toLocaleString(locale)}`;
      }
    }

    function plainDescription(html) {
      if (!html) return '';
      const template = document.createElement('template');
      template.innerHTML = html;
      return (template.content.textContent || '').replace(/\s+/g, ' ').trim();
    }

    function truncateWords(value, limit) {
      if (!value || value.length <= limit) return value;
      const shortened = value.slice(0, limit + 1).replace(/\s+\S*$/, '').trim();
      return `${shortened || value.slice(0, limit).trim()}…`;
    }

    function setQuickStatus(message = '', state = '') {
      if (!quickStatus) return;
      quickStatus.textContent = message;
      quickStatus.classList.toggle('is-error', state === 'error');
      quickStatus.classList.toggle('is-success', state === 'success');
    }

    function setQuickAddState({ disabled = false, busy = false, label } = {}) {
      if (!quickAdd) return;
      quickAdd.disabled = disabled;
      quickAdd.setAttribute('aria-busy', String(busy));
      if (quickAddLabel && label) quickAddLabel.textContent = label;
    }

    function resetQuickBuy() {
      clearTimeout(quickResetTimer);
      quickProduct = null;
      quickProductUrl = '';
      selectedOptions = [];
      selectedVariant = null;
      quickImages = [];
      quickImageIndex = 0;

      if (quickModal) {
        quickModal.dataset.loaded = 'false';
        quickModal.dataset.error = 'false';
        quickModal.dataset.imageReady = 'false';
      }

      if (quickImage) {
        quickImage.removeAttribute('src');
        quickImage.alt = '';
      }
      if (quickThumbnails) quickThumbnails.replaceChildren();
      if (quickDots) quickDots.replaceChildren();
      if (quickSpecs) { quickSpecs.replaceChildren(); quickSpecs.hidden = true; }
      if (quickTrust) { quickTrust.replaceChildren(); quickTrust.hidden = true; }
      if (quickRetry) quickRetry.hidden = true;
      if (quickImageError) quickImageError.hidden = true;
      if (quickScroll) quickScroll.scrollTop = 0;
      if (quickPanel) quickPanel.scrollTop = 0;
      if (quickImageCount) quickImageCount.textContent = '';
      if (quickGalleryPrev) quickGalleryPrev.hidden = true;
      if (quickGalleryNext) quickGalleryNext.hidden = true;
      if (quickTitle) quickTitle.textContent = quickModal?.dataset.loadingLabel || 'Loading piece…';
      if (quickPrice) quickPrice.textContent = '';
      if (quickDescription) { quickDescription.textContent = ''; quickDescription.hidden = true; }
      if (quickOptions) quickOptions.replaceChildren();
      if (quickQuantity) quickQuantity.value = '1';
      if (quickDetails) quickDetails.setAttribute('href', '#');
      if (quickCart) quickCart.hidden = true;
      if (quickTabs) {
        quickTabs.replaceChildren();
        quickTabs.hidden = true;
      }

      setQuickStatus();
      setQuickAddState({ disabled: true, busy: false, label: quickModal?.dataset.addLabel || 'ADD TO BAG' });
    }

    function showQuickImage(index) {
      if (!quickImages.length || !quickImage) return;
      quickImageIndex = (index + quickImages.length) % quickImages.length;
      const image = quickImages[quickImageIndex];
      if (quickModal) quickModal.dataset.imageReady = 'false';
      if (quickImageError) quickImageError.hidden = true;
      quickImage.src = normalizeImageUrl(image.src);
      quickImage.alt = image.alt || `${quickProduct?.title || 'Product'} — image ${quickImageIndex + 1}`;

      quickThumbnails?.querySelectorAll('[data-rd-thumbnail]').forEach((button, buttonIndex) => {
        const selected = buttonIndex === quickImageIndex;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-current', selected ? 'true' : 'false');
      });
      quickDots?.querySelectorAll('[data-rd-gallery-dot]').forEach((button, buttonIndex) => {
        const selected = buttonIndex === quickImageIndex;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-current', String(selected));
      });

      if (quickImageCount) quickImageCount.textContent = `${quickImageIndex + 1} / ${quickImages.length}`;
    }

    function renderQuickGallery(product) {
      const seen = new Set();
      quickImages = (product.images || []).map(image => {
        if (typeof image === 'string') return { src: image, alt: '' };
        return { src: image.src || image, alt: image.alt || '' };
      }).filter(image => {
        const source = normalizeImageUrl(image.src);
        if (!source || seen.has(source)) return false;
        seen.add(source);
        image.src = source;
        return true;
      });

      if (!quickImages.length && product.featured_image) {
        quickImages = [{ src: normalizeImageUrl(product.featured_image), alt: product.title || '' }];
      }

      if (quickThumbnails) {
        quickThumbnails.replaceChildren();
        quickImages.forEach((image, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'rd-quick-buy__thumbnail';
          button.dataset.rdThumbnail = String(index);
          button.setAttribute('aria-label', `Show image ${index + 1}`);

          const thumbnail = document.createElement('img');
          thumbnail.src = image.src;
          thumbnail.alt = '';
          thumbnail.loading = 'lazy';
          button.appendChild(thumbnail);
          quickThumbnails.appendChild(button);
        });
      }

      if (quickDots) {
        quickDots.replaceChildren();
        quickImages.forEach((image, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'rd-quick-buy__dot';
          dot.dataset.rdGalleryDot = String(index);
          dot.setAttribute('aria-label', `Show product image ${index + 1} of ${quickImages.length}`);
          quickDots.appendChild(dot);
        });
        quickDots.hidden = quickImages.length < 2;
      }
      const media = quickModal?.querySelector('[data-rd-quick-buy-gallery]');
      if (media) media.hidden = !quickImages.length;

      const multiple = quickImages.length > 1;
      if (quickGalleryPrev) quickGalleryPrev.hidden = !multiple;
      if (quickGalleryNext) quickGalleryNext.hidden = !multiple;
      if (quickThumbnails) quickThumbnails.hidden = !multiple;
      showQuickImage(0);
    }

    function showQuickImageBySource(source) {
      const normalized = normalizeImageUrl(source);
      if (!normalized) return;
      const basename = normalized.split('?')[0].split('/').pop();
      const index = quickImages.findIndex(image => {
        const candidate = normalizeImageUrl(image.src);
        return candidate === normalized || candidate.split('?')[0].split('/').pop() === basename;
      });
      if (index >= 0) showQuickImage(index);
    }

    function optionValues(product, position) {
      return [...new Set(product.variants.map(variant => variant.options[position]).filter(Boolean))];
    }

    function optionValueAvailable(position, value) {
      if (!quickProduct) return false;

      return quickProduct.variants.some(variant => {
        if (!variant.available || variant.options[position] !== value) return false;

        for (let index = 0; index < position; index += 1) {
          if (variant.options[index] !== selectedOptions[index]) return false;
        }
        return true;
      });
    }

    function renderOptionGroups() {
      if (!quickProduct || !quickOptions) return;
      quickOptions.replaceChildren();

      const isDefaultVariant = quickProduct.options?.length === 1 &&
        quickProduct.options[0]?.name === 'Title' &&
        optionValues(quickProduct, 0).every(value => value === 'Default Title');

      if (isDefaultVariant) return;

      (quickProduct.options || []).forEach((option, position) => {
        const group = document.createElement('fieldset');
        group.className = 'rd-quick-buy__option';

        const legend = document.createElement('legend');
        legend.className = 'rd-quick-buy__option-title';
        const optionName = option.name || `Option ${position + 1}`;
        const name = document.createElement('span');
        name.textContent = `${optionName}:`;
        const selectedValue = document.createElement('strong');
        selectedValue.dataset.rdSelectedOption = String(position);
        selectedValue.textContent = selectedOptions[position] || '';
        legend.append(name, selectedValue);

        const values = document.createElement('div');
        values.className = 'rd-quick-buy__option-values';
        const isVisualSwatch = /colou?r|crystal/i.test(optionName);

        optionValues(quickProduct, position).forEach(value => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `rd-quick-buy__option-button${isVisualSwatch ? ' rd-quick-buy__option-button--swatch' : ''}`;
          button.dataset.rdQuickOption = '';
          button.dataset.position = String(position);
          button.dataset.value = value;
          button.textContent = value;
          button.setAttribute('aria-label', value);
          button.title = value;

          if (isVisualSwatch) {
            button.style.setProperty('--rd-option-color', swatchFallback(value));
            const visualVariant = quickProduct.variants.find(variant =>
              variant.options[position] === value && variant.featured_image?.src
            );
            if (visualVariant?.featured_image?.src) {
              const escapedUrl = safeImageUrl(visualVariant.featured_image.src).replace(/"/g, '%22');
              button.style.setProperty('--rd-option-image', `url("${escapedUrl}")`);
            }
          }
          values.appendChild(button);
        });

        group.append(legend, values);
        quickOptions.appendChild(group);
      });
      applyQuickSwatches([]);
    }

    function applyQuickSwatches(swatches) {
      quickOptions?.querySelectorAll('.rd-quick-buy__option-button--swatch').forEach(button => {
        const key = cleanText(button.dataset.value).toLowerCase();
        const custom = quickSwatchOverrides.find(item => cleanText(item.value).toLowerCase() === key);
        const live = quickModal?.dataset.liveSwatches !== 'false' ? swatches.find(item => cleanText(item.value).toLowerCase() === key) : null;
        const image = safeImageUrl(custom?.image || live?.image);
        if (image) button.style.setProperty('--rd-option-image', `url(${JSON.stringify(image)})`);
        else if (custom?.color) button.style.removeProperty('--rd-option-image');
        if (custom?.color) button.style.setProperty('--rd-option-color', custom.color);
      });
    }

    function renderQuickDetails(details) {
      if (quickSpecs) {
        const labels = (quickModal.dataset.specLabels || 'Crystals, Metals').split(',').map(label => cleanText(label).toLowerCase()).filter(Boolean);
        quickSpecs.replaceChildren();
        labels.forEach(label => {
          const item = details.specs.find(spec => cleanText(spec.label).toLowerCase().replace(/s$/, '') === label.replace(/s$/, ''));
          if (!item) return;
          const row = document.createElement('div');
          const term = document.createElement('dt');
          term.textContent = item.label;
          const colon = document.createElement('span');
          colon.textContent = ':';
          colon.setAttribute('aria-hidden', 'true');
          term.appendChild(colon);
          const value = document.createElement('dd');
          value.textContent = item.value;
          row.append(term, value);
          quickSpecs.appendChild(row);
        });
        quickSpecs.hidden = !quickSpecs.children.length;
      }
      if (quickDescription && quickModal?.dataset.showDescription !== 'true') {
        quickDescription.hidden = !quickSpecs || !quickSpecs.hidden || !quickDescription.textContent;
      }
      applyQuickSwatches(details.swatches);
      renderQuickTrust(details.trust);
      if (quickTabs) renderQuickTabs(details.tabs);
    }

    function renderQuickTrust(live = {}) {
      if (!quickTrust) return;
      quickTrust.replaceChildren();
      const source = quickModal.dataset.trustSource;
      if (source === 'none') { quickTrust.hidden = true; return; }
      let { rating = '', reviewText = '', hotels = [] } = live;
      if (source === 'editor') {
        const text = cleanText(quickModal.dataset.reviewsText);
        const match = text.match(/^([0-5](?:\.\d+)?)\s*(.*)$/);
        rating = match ? match[1] : '';
        reviewText = match ? match[2] : text;
        hotels = (quickModal.dataset.featuredText || '').split('|').map(cleanText).filter(Boolean);
      }
      const ratingNumber = Number(rating);
      if (quickModal.dataset.showReviews === 'true' && reviewText && (!rating || (ratingNumber >= 0 && ratingNumber <= 5))) {
        const reviews = document.createElement('p');
        reviews.className = 'rd-quick-buy__reviews';
        if (rating) {
          const stars = document.createElement('span');
          stars.className = 'rd-quick-buy__stars';
          stars.textContent = '★'.repeat(Math.round(ratingNumber));
          stars.setAttribute('aria-hidden', 'true');
          const score = document.createElement('strong');
          score.textContent = rating;
          reviews.append(stars, score);
        }
        const text = document.createElement('span');
        text.textContent = reviewText;
        reviews.appendChild(text);
        quickTrust.appendChild(reviews);
      }
      if (quickModal.dataset.showFeatured === 'true' && hotels.length) {
        const logos = document.createElement('div');
        logos.className = 'rd-quick-buy__hotel-names';
        logos.setAttribute('aria-label', quickModal.dataset.featuredLabel || 'Featured at luxury hotels');
        hotels.forEach(name => {
          const item = document.createElement('span');
          item.textContent = name;
          logos.appendChild(item);
        });
        quickTrust.appendChild(logos);
      }
      quickTrust.hidden = !quickTrust.children.length;
    }

    function handleQuickImageLoad() {
      if (quickModal) quickModal.dataset.imageReady = 'true';
      if (quickImageError) quickImageError.hidden = true;
    }

    function handleQuickImageError() {
      if (quickModal) quickModal.dataset.imageReady = 'false';
      if (quickImageError) quickImageError.hidden = false;
    }

    function updateQuickVariant() {
      if (!quickProduct) return;

      selectedVariant = quickProduct.variants.find(variant =>
        variant.options.every((value, position) => value === selectedOptions[position])
      ) || null;

      quickOptions?.querySelectorAll('[data-rd-quick-option]').forEach(button => {
        const position = Number(button.dataset.position);
        const value = button.dataset.value;
        const isSelected = selectedOptions[position] === value;
        const isAvailable = optionValueAvailable(position, value);

        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', String(isSelected));
        button.disabled = !isAvailable;
        button.setAttribute('aria-disabled', String(!isAvailable));
      });

      quickOptions?.querySelectorAll('[data-rd-selected-option]').forEach(label => {
        label.textContent = selectedOptions[Number(label.dataset.rdSelectedOption)] || '';
      });

      if (quickPrice) {
        quickPrice.replaceChildren();
        const price = document.createElement('span');
        price.textContent = formatMoney(selectedVariant?.price ?? quickProduct.price);
        quickPrice.appendChild(price);

        if (selectedVariant?.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
          const compare = document.createElement('s');
          compare.textContent = formatMoney(selectedVariant.compare_at_price);
          quickPrice.appendChild(compare);
        }
      }

      const variantImage = selectedVariant?.featured_image?.src || quickProduct.featured_image;
      if (variantImage) showQuickImageBySource(variantImage);

      const available = Boolean(selectedVariant?.available);

      if (quickDetails && quickProductUrl) {
        const detailsUrl = new URL(quickProductUrl, window.location.origin);
        if (selectedVariant?.id) detailsUrl.searchParams.set('variant', selectedVariant.id);
        quickDetails.href = `${detailsUrl.pathname}${detailsUrl.search}${detailsUrl.hash}`;
      }

      setQuickAddState({
        disabled: !available || quickAdding,
        busy: quickAdding,
        label: quickAdding ? (quickModal?.dataset.addingLabel || 'ADDING…') : available ? (quickModal?.dataset.addLabel || 'ADD TO BAG') : (quickModal?.dataset.unavailableLabel || 'UNAVAILABLE')
      });
      setQuickStatus();
      if (quickCart) quickCart.hidden = true;
    }

    function selectOption(position, value) {
      if (!quickProduct) return;
      selectedOptions[position] = value;

      const compatible = quickProduct.variants.find(variant => {
        if (!variant.available) return false;
        for (let index = 0; index <= position; index += 1) {
          if (variant.options[index] !== selectedOptions[index]) return false;
        }
        return true;
      });

      if (compatible) {
        for (let index = position + 1; index < compatible.options.length; index += 1) {
          selectedOptions[index] = compatible.options[index];
        }
      }

      updateQuickVariant();
    }

    function activateQuickTab(index) {
      if (!quickTabs) return;
      quickTabs.querySelectorAll('[data-rd-quick-tab]').forEach((button, buttonIndex) => {
        const active = buttonIndex === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      quickTabs.querySelectorAll('[data-rd-quick-tab-panel]').forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });
    }

    function renderQuickTabs(tabs) {
      if (!quickTabs || !tabs?.length) return;
      quickTabs.replaceChildren();

      const nav = document.createElement('div');
      nav.className = 'rd-quick-buy__tab-nav';
      nav.setAttribute('role', 'tablist');

      tabs.forEach((tab, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rd-quick-buy__tab-button';
        button.dataset.rdQuickTab = String(index);
        button.id = `RDQuickTab-${sectionId}-${index}`;
        button.setAttribute('aria-controls', `RDQuickPanel-${sectionId}-${index}`);
        button.setAttribute('role', 'tab');
        button.textContent = tab.label;
        nav.appendChild(button);
      });

      quickTabs.appendChild(nav);
      tabs.forEach((tab, index) => {
        const panel = document.createElement('div');
        panel.className = 'rd-quick-buy__tab-panel';
        panel.dataset.rdQuickTabPanel = String(index);
        panel.id = `RDQuickPanel-${sectionId}-${index}`;
        panel.setAttribute('aria-labelledby', `RDQuickTab-${sectionId}-${index}`);
        panel.setAttribute('role', 'tabpanel');
        panel.innerHTML = tab.html;
        quickTabs.appendChild(panel);
      });

      quickTabs.hidden = false;
      activateQuickTab(0);
    }

    function renderQuickProduct(product, productUrl) {
      quickProduct = product;
      quickProductUrl = productUrl;
      const requestedVariantId = Number(new URL(productUrl, window.location.origin).searchParams.get('variant'));
      const requestedVariant = product.variants.find(variant => variant.id === requestedVariantId);
      const defaultVariant = requestedVariant || product.variants.find(variant => variant.available) || product.variants[0];
      selectedOptions = defaultVariant?.options ? [...defaultVariant.options] : [];

      if (quickTitle) quickTitle.textContent = product.title || '';
      if (quickDetails) quickDetails.href = productUrl;

      if (quickDescription) {
        const limit = Math.max(0, Number(root.dataset.quickDescriptionLength || 160));
        quickDescription.textContent = truncateWords(plainDescription(product.description), limit);
        quickDescription.hidden = quickModal?.dataset.showDescription !== 'true' || !quickDescription.textContent;
      }

      renderQuickGallery(product);
      renderOptionGroups();
      updateQuickVariant();
      if (quickModal) quickModal.dataset.loaded = 'true';
    }

    async function openQuickBuy(trigger) {
      if (!quickModal || !trigger || trigger.disabled) return;
      const productUrl = trigger.dataset.productUrl;
      if (!productUrl) return;

      if (drawer?.dataset.open === 'true') closeDrawer({ restoreFocus: false });

      previousActive = trigger;
      resetQuickBuy();
      quickModal.dataset.open = 'true';
      quickModal.setAttribute('aria-hidden', 'false');
      lockBody();
      isolateDialog(quickModal);

      requestAnimationFrame(() => {
        if (quickModal.dataset.open === 'true') quickPanel?.focus({ preventScroll: true });
      });

      quickRequestController?.abort();
      quickRequestController = new AbortController();
      const controller = quickRequestController;

      if (quickDetails) quickDetails.href = productUrl;
      renderQuickTrust();
      const needsDetails = Boolean(quickSpecs || quickTabs || quickTrust || quickModal.dataset.liveSwatches !== 'false');
      // Start both reads together, without delaying a usable product form.
      const detailsRequest = needsDetails ? fetchProductDetails(productUrl, controller).catch(() => null) : Promise.resolve(null);

      try {
        const product = await fetchProduct(productUrl, controller);
        if (controller.signal.aborted || controller !== quickRequestController || quickModal.dataset.open !== 'true') return;
        renderQuickProduct(product, productUrl);

        const details = await detailsRequest;
        if (!controller.signal.aborted && controller === quickRequestController && quickModal.dataset.open === 'true' && quickProductUrl === productUrl) {
          if (details) renderQuickDetails(details);
          else if (quickDescription && (quickSpecs || quickModal.dataset.showDescription === 'true')) quickDescription.hidden = !quickDescription.textContent;
        }
      } catch (error) {
        if (error.name === 'AbortError' || controller.signal.aborted || controller !== quickRequestController || quickModal.dataset.open !== 'true') return;

        if (quickModal) {
          quickModal.dataset.loaded = 'true';
          quickModal.dataset.error = 'true';
        }
        if (quickTitle) quickTitle.textContent = 'Unable to load this piece';
        if (quickRetry) quickRetry.hidden = false;
        setQuickStatus(quickModal?.dataset.loadErrorLabel || 'Unable to load this piece.', 'error');
        console.error('[RD Luxury Collection Quick Buy]', error);
      }
    }

    function closeQuickBuy() {
      if (!quickModal || quickModal.dataset.open !== 'true') return;

      quickRequestController?.abort();
      quickModal.dataset.open = 'false';
      quickModal.setAttribute('aria-hidden', 'true');
      if (drawer?.dataset.open !== 'true') {
        restoreBackground();
        unlockBody();
      }

      if (previousActive?.focus) {
        try {
          previousActive.focus({ preventScroll: true });
        } catch (_) {}
      }
    }

    function cartRoot() {
      return window.Shopify?.routes?.root || '/';
    }

    function updateCartCount(cart) {
      if (!cart || typeof cart.item_count !== 'number') return;

      document.querySelectorAll('[data-cart-count]').forEach(element => {
        element.textContent = String(cart.item_count);
        element.hidden = false;
      });

      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(element => {
        element.textContent = String(cart.item_count);
      });
    }

    function announceCartUpdate(cart, item) {
      const detail = { cart, item, source: 'rd-luxury-collection-quick-buy' };
      document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail }));
    }

    async function addQuickProduct(event) {
      event.preventDefault();
      if (quickAdding || !selectedVariant?.available || !quickAdd) return;

      quickAdding = true;
      const variantId = selectedVariant.id;
      const controller = quickRequestController;
      const sameSelection = () => quickModal?.dataset.open === 'true' && controller === quickRequestController && !controller?.signal.aborted && selectedVariant?.id === variantId;
      clearTimeout(quickResetTimer);

      const quantity = Math.max(1, Math.min(99, Number.parseInt(quickQuantity?.value || '1', 10) || 1));
      if (quickQuantity) quickQuantity.value = String(quantity);

      setQuickStatus();
      setQuickAddState({ disabled: true, busy: true, label: quickModal?.dataset.addingLabel || 'ADDING…' });

      try {
        const response = await fetch(`${cartRoot()}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] })
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add product.');

        let cart = null;
        try {
          const cartResponse = await fetch(`${cartRoot()}cart.js`, { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) cart = await cartResponse.json();
        } catch (_) {}

        updateCartCount(cart);
        announceCartUpdate(cart, result.items?.[0] || result);
        if (!sameSelection()) return;
        setQuickStatus(quickModal?.dataset.addedLabel || 'ADDED TO BAG', 'success');
        setQuickAddState({ disabled: false, busy: false, label: quickModal?.dataset.addedLabel || 'ADDED TO BAG' });
        if (quickCart) quickCart.hidden = false;

        quickResetTimer = window.setTimeout(() => {
          if (!sameSelection() || quickAdding) return;
          setQuickAddState({ disabled: !selectedVariant?.available, busy: false, label: selectedVariant?.available ? (quickModal?.dataset.addLabel || 'ADD TO BAG') : (quickModal?.dataset.unavailableLabel || 'UNAVAILABLE') });
        }, 2200);
      } catch (error) {
        if (!sameSelection()) return;
        const fallback = quickModal?.dataset.errorLabel || 'Unable to add this piece. Please try again.';
        setQuickStatus(error.message || fallback, 'error');
        setQuickAddState({ disabled: false, busy: false, label: quickModal?.dataset.addLabel || 'ADD TO BAG' });
        console.error('[RD Luxury Collection Quick Buy]', error);
      } finally {
        quickAdding = false;
        if (!sameSelection() && quickModal?.dataset.open === 'true' && quickProduct) {
          setQuickAddState({ disabled: !selectedVariant?.available, busy: false, label: selectedVariant?.available ? (quickModal?.dataset.addLabel || 'ADD TO BAG') : (quickModal?.dataset.unavailableLabel || 'UNAVAILABLE') });
        }
      }
    }

    function handleRootClick(event) {
      const layoutButton = event.target.closest('button[data-rd-layout]');
      if (layoutButton && root.contains(layoutButton)) {
        changeLayout(layoutButton);
        return;
      }
      const cardSwatch = event.target.closest('[data-rd-card-swatch]');
      if (cardSwatch && root.contains(cardSwatch)) {
        event.preventDefault();
        if (swatchInteraction === 'hover' && supportsFineHover && event.detail > 0) return;
        selectCardSwatch(cardSwatch);
        return;
      }

      const quickTrigger = event.target.closest('[data-rd-quick-buy-open]');
      if (quickTrigger && root.contains(quickTrigger)) {
        event.preventDefault();
        openQuickBuy(quickTrigger);
        return;
      }

      const optionButton = event.target.closest('[data-rd-quick-option]');
      if (optionButton && quickModal?.contains(optionButton)) {
        selectOption(Number(optionButton.dataset.position), optionButton.dataset.value);
        return;
      }

      const thumbnail = event.target.closest('[data-rd-thumbnail]');
      if (thumbnail && quickModal?.contains(thumbnail)) {
        showQuickImage(Number(thumbnail.dataset.rdThumbnail));
        return;
      }

      const dot = event.target.closest('[data-rd-gallery-dot]');
      if (dot && quickModal?.contains(dot)) {
        showQuickImage(Number(dot.dataset.rdGalleryDot));
        return;
      }
      if (event.target.closest('[data-rd-quick-buy-retry]') && previousActive) {
        openQuickBuy(previousActive);
        return;
      }

      if (event.target.closest('[data-rd-gallery-prev]')) {
        showQuickImage(quickImageIndex - 1);
        return;
      }

      if (event.target.closest('[data-rd-gallery-next]')) {
        showQuickImage(quickImageIndex + 1);
        return;
      }

      const tabButton = event.target.closest('[data-rd-quick-tab]');
      if (tabButton && quickTabs?.contains(tabButton)) {
        activateQuickTab(Number(tabButton.dataset.rdQuickTab));
        return;
      }

      if (event.target.closest('[data-rd-quantity-minus]')) {
        const current = Number.parseInt(quickQuantity?.value || '1', 10) || 1;
        if (quickQuantity) quickQuantity.value = String(Math.max(1, current - 1));
        return;
      }

      if (event.target.closest('[data-rd-quantity-plus]')) {
        const current = Number.parseInt(quickQuantity?.value || '1', 10) || 1;
        if (quickQuantity) quickQuantity.value = String(Math.min(99, current + 1));
      }
    }

    function handleGalleryTouchStart(event) {
      quickTouchStartX = event.changedTouches?.[0]?.clientX ?? null;
      quickTouchStartY = event.changedTouches?.[0]?.clientY ?? null;
    }

    function handleGalleryTouchEnd(event) {
      if (quickTouchStartX === null || quickImages.length < 2) return;
      const endX = event.changedTouches?.[0]?.clientX;
      const endY = event.changedTouches?.[0]?.clientY;
      if (typeof endX !== 'number') return;
      const distance = endX - quickTouchStartX;
      const vertical = typeof endY === 'number' ? endY - quickTouchStartY : 0;
      quickTouchStartX = null;
      quickTouchStartY = null;
      if (Math.abs(distance) < 42 || Math.abs(distance) <= Math.abs(vertical)) return;
      showQuickImage(quickImageIndex + (distance < 0 ? 1 : -1));
    }

    function handleUnload(event) {
      if (!event.detail?.sectionId || !root.id.endsWith(event.detail.sectionId)) return;

      disposed = true;
      if (mobileLayoutFrame !== null) cancelAnimationFrame(mobileLayoutFrame);
      clearTimeout(headerTransitionTimer);
      mobileLayoutObserver?.disconnect();
      headerMutationObserver?.disconnect();
      window.removeEventListener('scroll', queueMobileLayout);
      window.removeEventListener('resize', queueMobileLayout);
      window.visualViewport?.removeEventListener('resize', queueMobileLayout);
      stickyHeaders.forEach(header => header.removeEventListener('transitionend', queueMobileLayout));
      if (mobileControlsMedia?.removeEventListener) mobileControlsMedia.removeEventListener('change', queueMobileLayout);
      else mobileControlsMedia?.removeListener?.(queueMobileLayout);
      document.removeEventListener('shopify:block:select', handleBlockSelect);
      root.classList.remove('mobile-controls-ready');
      root.dataset.mobileToolsActive = 'false';
      requestController?.abort();
      quickRequestController?.abort();
      clearTimeout(quickResetTimer);
      collectionFilters?.destroy();
      if (desktopFilterMedia?.removeEventListener) desktopFilterMedia.removeEventListener('change', handleFilterBreakpoint);
      else desktopFilterMedia?.removeListener?.(handleFilterBreakpoint);
      revealObserver?.disconnect();
      imageSizeObserver?.disconnect();
      restoreBackground();
      unlockBody();
      document.removeEventListener('keydown', handleKeydown);
      root.removeEventListener('click', handleRootClick);
      root.removeEventListener('pointerover', handleSwatchPointerOver);
      root.removeEventListener('pointerout', handleSwatchPointerOut);
      sortSelect?.removeEventListener('change', changeSort);
      filterForm?.removeEventListener('submit', applyFilters);
      quickImageStage?.removeEventListener('touchstart', handleGalleryTouchStart);
      quickImageStage?.removeEventListener('touchend', handleGalleryTouchEnd);
      quickImage?.removeEventListener('load', handleQuickImageLoad);
      quickImage?.removeEventListener('error', handleQuickImageError);
      quickForm?.removeEventListener('submit', addQuickProduct);
      document.removeEventListener('shopify:section:unload', handleUnload);
    }

    openFilterButton?.addEventListener('click', openDrawer);
    closeFilterButtons.forEach(button => button.addEventListener('click', () => closeDrawer()));
    quickCloseButtons.forEach(button => button.addEventListener('click', closeQuickBuy));
    quickForm?.addEventListener('submit', addQuickProduct);
    root.addEventListener('click', handleRootClick);
    root.addEventListener('pointerover', handleSwatchPointerOver);
    root.addEventListener('pointerout', handleSwatchPointerOut);
    quickImageStage?.addEventListener('touchstart', handleGalleryTouchStart, { passive: true });
    quickImageStage?.addEventListener('touchend', handleGalleryTouchEnd, { passive: true });
    quickImage?.addEventListener('load', handleQuickImageLoad);
    quickImage?.addEventListener('error', handleQuickImageError);
    document.addEventListener('keydown', handleKeydown);

    sortSelect?.addEventListener('change', changeSort);
    filterForm?.addEventListener('submit', applyFilters);

    revealObserver = createRevealObserver();
    if (revealObserver) root.classList.add('is-revealing');
    applyCardSwatchFallbacks(root);
    reveal([...root.querySelectorAll('[data-rd-product-card], [data-rd-editorial-card]')]);
    if ('ResizeObserver' in window && grid) {
      imageSizeObserver = new ResizeObserver(updateCardImageSizes);
      imageSizeObserver.observe(grid);
    }

    if (loadMore && grid) {
      root.classList.add('is-enhanced');
      loadButton?.addEventListener('click', loadNextPage);

      const initialVisible = Number(loadMore.dataset.visible || 0);
      const total = Number(loadMore.dataset.total || 0);
      updateProgress(initialVisible, total);

      if (!nextUrl && loadButton) setCompleteState();
    }

    document.addEventListener('shopify:section:unload', handleUnload);
    collectionFilters = window.RDCollectionFilters?.init(root, cards => {
      applyCardSwatchFallbacks(root);
      cards.forEach(card => {
        const variant = card._rdFilterVariant;
        if (!variant) return;
        const swatch = [...card.querySelectorAll('[data-rd-card-swatch]')].find(button => Number(button.dataset.variantId) === variant.id);
        if (swatch) { selectCardSwatch(swatch); return; }
        card.querySelectorAll('[data-rd-card-swatch]').forEach(button => {
          button.setAttribute('aria-pressed', 'false');
          button.classList.remove('is-selected');
        });
        card.querySelectorAll('.rd-product-card__image-link, .rd-product-card__title a').forEach(link => {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('variant', variant.id);
          link.href = `${url.pathname}${url.search}${url.hash}`;
        });
        card.querySelectorAll('[data-rd-quick-buy-open]').forEach(button => {
          const url = new URL(button.dataset.productUrl, window.location.origin);
          url.searchParams.set('variant', variant.id);
          button.dataset.productUrl = `${url.pathname}${url.search}${url.hash}`;
        });
        const price = card.querySelector('[data-rd-card-price]');
        if (price && variant.priceLabel) {
          const current = document.createElement('span'); current.textContent = variant.priceLabel;
          price.replaceChildren(current);
          if (variant.compareLabel && root.dataset.showComparePrice !== 'false') {
            const compare = document.createElement('s'); compare.textContent = variant.compareLabel; price.appendChild(compare);
          }
        }
        const label = variant.options.join(' / ');
        if (variant.image) applyCardImage(card, variant.image, label);
        const colorLabel = card.querySelector('[data-rd-swatch-label]'); if (colorLabel) colorLabel.textContent = label;
        card._rdSelectedImage = captureCardImage(card);
      });
      reveal(cards);
      updateCardImageSizes();
    });
    if (desktopFilterMedia?.addEventListener) desktopFilterMedia.addEventListener('change', handleFilterBreakpoint);
    else desktopFilterMedia?.addListener?.(handleFilterBreakpoint);
    syncFilterGroups();
    syncFilterPresentation();
    root.classList.add('mobile-controls-ready');
    window.addEventListener('scroll', queueMobileLayout, { passive: true });
    window.addEventListener('resize', queueMobileLayout, { passive: true });
    window.visualViewport?.addEventListener('resize', queueMobileLayout, { passive: true });
    if (mobileControlsMedia?.addEventListener) mobileControlsMedia.addEventListener('change', queueMobileLayout);
    else mobileControlsMedia?.addListener?.(queueMobileLayout);
    document.addEventListener('shopify:block:select', handleBlockSelect);
    stickyHeaders.forEach(header => header.addEventListener('transitionend', queueMobileLayout));
    if ('ResizeObserver' in window) {
      mobileLayoutObserver = new ResizeObserver(queueMobileLayout);
      [mobileTools, mobileCategories, root, ...stickyHeaders].filter(Boolean).forEach(element => mobileLayoutObserver.observe(element));
    }
    if ('MutationObserver' in window && stickyHeaders.length) {
      headerMutationObserver = new MutationObserver(settleHeaderTransition);
      stickyHeaders.forEach(header => headerMutationObserver.observe(header, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] }));
    }
    syncMobileControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
